import { useContext } from "react";
import { TooltipProvider } from "@pushpress/pushpress-ui";
import { AblyProvider, ChannelProvider } from "ably/react";
import * as Ably from "ably";
import MigrationAssistant from "./MigrationAssistant";
import {
  ABLY_API_KEY_DEV,
  ABLY_API_KEY_STAGE,
  ABLY_API_KEY_PROD,
} from "./constants";
import { AppContext } from "../../context/app";
import { isStage, isProd } from "../../env";

const getAblyApiKey = () => {
  if (isProd()) return ABLY_API_KEY_PROD;
  if (isStage()) return ABLY_API_KEY_STAGE;
  return ABLY_API_KEY_DEV;
};

const client = new Ably.Realtime({
  key: getAblyApiKey(),
});

export default function App() {
  const app = useContext(AppContext);

  return (
    <>
      <AblyProvider client={client}>
        <ChannelProvider
          channelName={`client.${app.client.uuid}.automated.migrations`}
        >
          <TooltipProvider delayDuration={200}>
            <MigrationAssistant />
          </TooltipProvider>
        </ChannelProvider>
      </AblyProvider>
    </>
  );
}
